export * from './gotoLine-quick-access-resolver';
